export default {
  DEDICATED_IP: 'ip',
  IP_COST: 30,
  EASE: 'ease',
};



// WEBPACK FOOTER //
// ./src/constants/addOns.js